module.exports = {"411281001":"千秋路街道","411281002":"朝阳路街道","411281003":"新义街街道","411281004":"常村路街道","411281005":"泰山路街道","411281006":"新区街道","411281007":"东区街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/411281.json
// module id = 1758
// module chunks = 0